import React, {useState, useEffect, useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import useAlert from "@hooks/useAlert";
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  FormControl,
  FormControlLabel,
  Checkbox,
  FormHelperText,
  Grid,
  Box,
  Typography,
  Container,
} from '@mui/material/';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import styled from 'styled-components';
import WebService from '../util/webService';
import useSnackbar from '../hooks/useSnackbar';
import { setAccount } from '../redux/actions/accountAction';
import { isAdmin, isStringNullOrEmpty } from '../util/helper';
import useIndicator from "@hooks/useIndicator";
import { useTheme } from '@mui/material/styles';
import { isExpired, decodeToken } from "react-jwt";
import NaverLogin from '@oauth/NaverLogin';
import KakaoLogin from '@oauth/KakaoLogin';
import no_image from '@images/no_image.png'
import QrLogin from '@pages/QrLogin'
import logo from '@images/logo_white.png'
import logoText from '@images/logo_green.png'
import logo140 from '@images/icon_140.png'
// mui의 css 우선순위가 높기때문에 important를 설정 - 실무하다 보면 종종 발생 우선순위 문제
const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`;

//
const Boxs = styled(Box)`
  padding-bottom: 40px !important;
`;

export const afterLogin = async (resp, dispatch) => {
  const repMessage = JSON.parse(resp.repMessage)
  const account = JSON.parse(repMessage.account)
  dispatch(setAccount(account))

  const token = repMessage.token
  const decoded = decodeToken(token)

  const accessToken = repMessage.accessToken
  localStorage.setItem('accessToken',accessToken)

  const refreshToken = repMessage.refreshToken
  localStorage.setItem('refreshToken', refreshToken)

  const deviceId = repMessage.deviceId
  localStorage.setItem('deviceId', deviceId )

  return ''
}

export const processLogin = async(url, data, dispatch) => {
  const resp = await WebService.post(url, data)

  if(resp.repCode !== 'ack') {
    // alert(resp.repMessage)
    return resp.repMessage
  }

  return afterLogin(resp, dispatch)

  /*
  const repMessage = JSON.parse(resp.repMessage)
  const account = JSON.parse(repMessage.account)
  dispatch(setAccount(account))

  const token = repMessage.token
  const decoded = decodeToken(token)

  const accessToken = repMessage.accessToken
  localStorage.setItem('accessToken',accessToken)

  const refreshToken = repMessage.refreshToken
  localStorage.setItem('refreshToken', refreshToken)

  const deviceId = repMessage.deviceId
  localStorage.setItem('deviceId', deviceId )

  return ''
  */
}

const LoginPage = () => {
  const theme = useTheme();
  const navigate = useNavigate()
  const [loginId, set_loginId] = useState('')
  const [password, set_password] = useState('')
  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const dispatch = useDispatch()
  const {alert, renderAlert} = useAlert()
  const buttonRef = useRef(null)
  const qrHandler = useState(false)
  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      buttonRef.current.click();
    }
  };


  const canLogin = () => {
    return loginId && password
  }
  
  const onLogin = async () => {
    const url = '/login'
    if(isStringNullOrEmpty(loginId) || isStringNullOrEmpty(password)) {
      openSnackbar('아이디 또는 패스워드를 입력하세요.')
      return
    }
    const data = {loginId: loginId, password: password}
    const ret = await processLogin(url, data, dispatch)
    if(ret != '') {
      alert(ret)
      return
    }
    navigate('/')

  }


  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  return (
		<>
			<Container component='main' maxWidth='xs'>
				<CssBaseline />
        {qrHandler[0] ? (<QrLogin dialogHandler={qrHandler} />) : null }
				<Box
					sx={{
						marginTop: 8,
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
					}}>
            {/* <Avatar sx={{ m: 1, bgcolor: "primary.bar" }} /> */}
          <div style={{width:'100%', display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'row'}}>
            <div style={{display:'flex', flex:1}}>
              {/* <div style={{
                borderRadius:'25%',
                border:'2px solid #1aa95d',
                width:35,
                height:35, // 높이도 지정해야 원형됨
                overflow:'hidden', // 둥글게 잘리도록
                display:'flex',
                alignItems:'center',
                justifyContent:'center',
                padding:3
              }}>
                  <img src={logo} alt='logo' style={{width: '100%', }} />
              </div> */}
              
            </div>
            <div style={{display:'flex', flex:2, alignItems:'center', justifyContent:'center'}}>
              <div style={{
                borderRadius:'25%',
                border:'0px solid #1aa95d',
                width:35,
                height:35, // 높이도 지정해야 원형됨
                overflow:'hidden', // 둥글게 잘리도록
                display:'flex',
                alignItems:'center',
                justifyContent:'center',
              }}>
                  <img src={logo140} alt='logo140' style={{width: '100%', }} />
              </div>
              <img src={logoText} alt='logoText' style={{width: 110, margin:20}} />
            </div>
            <div style={{display:'flex', flex:1}}></div>
            
            
          </div>
           
					<Boxs component='form' noValidate sx={{ mt: 3 }}>
						<FormControl component='fieldset' variant='standard'>
							<Grid container spacing={2}>
								<Grid item xs={12}>
									<TextField
										required
										autoFocus
										fullWidth
										type='text'
										id='loginId'
										name='loginId'
										label='아이디(이메일)'
                    size='md'
										onChange={(e) => {
											set_loginId(e.target.value)
										}}
									/>
								</Grid>
								<Grid item xs={12}>
									<TextField
										required
										fullWidth
										type='password'
										id='password'
										name='password'
										label='패스워드'
                    size='md'
										onChange={(e) => {
											set_password(e.target.value)
										}}
									/>
								</Grid>
                <Grid item xs={12}>
                  <Button
                    fullWidth
                    ref={buttonRef}
                    variant='contained'
                    size='large'
                    disabled={!canLogin()}
                    onClick={() => onLogin()}>
                    
                    로그인
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Button
                    fullWidth
                    variant='contained'
                    size='large'
                    // color='secondary'
                    sx={{ 
                      backgroundColor: "#1aa95d", 
                      color: "#fff",
                      "&:hover": {
                        backgroundColor: "#45a049"
                      }
                    }}
                    onClick={() => {
                     qrHandler[1](true)
                    }}>
                    QR 코드 로그인
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    <Grid
                      item
                      xs={6}
                      style={{ display: "flex", justifyContent: "center" }}>
                      <Button
                        variant='text'
                        onClick={() => navigate("/public/find/id")}
                      >
                        아이디 찾기
                      </Button>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      style={{ display: "flex", justifyContent: "center" }}>
                      <Button
                        variant='text'
                        onClick={() => navigate("/public/find/password")}
                      >
                        패스워드 재설정
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                {/* <Grid item xs={12}>
                  <Grid container spacing={2} >
                    <Grid item xs={3}></Grid>
                    <Grid item xs={3}>
                      <NaverLogin />
                    </Grid>
                    <Grid item xs={3}>
                      <KakaoLogin />
                    </Grid>
                    <Grid item xs={3}></Grid>
                  </Grid>
                </Grid> */}
                <Grid item xs={12}>
                  <Typography variant='body2' style={{color:'#9e9e9e'}}>
                    스쿨매니저 모바일 앱을 사용하면 네이버 또는 카카오등의 소셜 로그인 기능으로 보다 쉽게 회원 가입을 하실 수 있습니다.
                    (구글플레이 또는 앱스토어에서 '스쿨매니저'를 검색하세요.)
                  </Typography>
                  
                  <Typography variant='body2' style={{color:'#9e9e9e', marginTop:10}}>
                    공용 PC 사용 시 비밀번호가 노출 되는 등의 보안 상의 사고가 발생할 우려가 있어 PC 웹에서는 소셜로그인 기능을 지원하지 않습니다.
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Button
                    fullWidth
                    variant='contained'
                    size='large'
                    onClick={() => {
                      navigate("/register/user")
                    }}>
                    회원 가입
                  </Button>
                </Grid>
                
							</Grid>
							
              {/*
              <Button
                fullWidth
                variant='contained'
                sx={{ mt: 2 }}
                color='info'
                size='large'
                onClick={() => {
                  navigate("/register/company")
                }}>
                위탁업체 등록
              </Button>
              */}
							
						</FormControl>
					</Boxs>
				</Box>
			</Container>
			{renderSnackbar()}
			{renderIndicator()}
      {renderAlert()}
		</>
	)
};

export default LoginPage;
